module.exports = __webpack_public_path__ + "img/73.91c056c0.jpg";